import React, { Component } from 'react';
import { graphql } from 'gatsby';
import { Layout, Wrapper } from '../components';
import { StoriesList } from '../components/Stories';

class Category extends Component {
  render() {
    const {
      data: {
        site: {
          siteMetadata,
        },
        page: {
          data: pageData,
        },
        settings,
        stories,
        categories,
      },
      location,
      pageContext,
    } = this.props;
    const {
      storiesSlug,
      categorySlug,
    } = siteMetadata;
    const {
      metaTitle,
      metaDescription,
      openGraphImage,
    } = pageData;
    const seoData = {
      metaTitle,
      metaDescription,
      openGraphImage,
    };
    const storyItems = stories && stories.edges.map(storyItem => storyItem.node);
    const categoryItems = categories && categories.edges.map(categoryItem => categoryItem.node);
    const pathPrefix = `/${storiesSlug}/${categorySlug}/`;
    return (
      <Layout location={location} seoData={seoData}>
        <Wrapper>
          <StoriesList
            stories={storyItems}
            categories={categoryItems}
            settings={settings}
            siteMetadata={siteMetadata}
            location={location}
            pageContext={pageContext}
            pathPrefix={pathPrefix}
          />
        </Wrapper>
      </Layout>
    );
  }
}

export default Category;

export const pageQuery = graphql`
  query CategoryPage($categoryUid: String!, $limit: Int!, $skip: Int!) {
    site {
      siteMetadata {
        storiesSlug,
        categorySlug,
      }
    }
    page: prismicCategory(uid: { eq: $categoryUid }) {
      uid,
      data {
        metaTitle: meta_title {
          html
          text
        },
        metaDescription: meta_description {
          html
          text
        },
        openGraphImage: open_graph_image {
          alt
          copyright
          url
        }
      }
    }
    settings: prismicSettings {
      data {
        socialLinks: social_links {
          type
          link {
            url
            target
          }
        }
      }
    }
    stories: allPrismicStory(
      limit: $limit
      skip: $skip
      sort: { fields: [data___date], order: DESC }
      filter: {
        data: {
          category: {
            uid: { eq: $categoryUid }
          }
        }
      }
    ) {
      edges {
        node {
          uid
          data {
            storyName: page_name {
              html
              text
            }
            eventDate: date(formatString: "DD MMM YYYY")
            eventLocation: location {
              html
              text
            }
            feedImage: feed_image {
              alt
              localFile {
                childImageSharp {
                  fluid(maxWidth: 800, quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            feedImageOrientation: feed_image_orientation
            category {
              uid
            }
          }
        }
      }
    }
    categories: allPrismicCategory {
      edges {
        node {
          uid
          data {
            categoryName: category_name {
              text
            }
          }
        }
      }
    }
  }
`;
